// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"247ec22c","272":"147b79c2","307":"30c4515b","332":"cd4e0c04","422":"00fc3f26","453":"6e65e14c","545":"e61568d4","796":"43a9f422","843":"138c7423"}[chunkId] + ".chunk.js";
};